// src/components/shared/FilterPanel.js
// Wrapper canônico de filter panel expansível usado nas listings (Home, Farm,
// Corral, bulls/List, Users/List, etc.) — 2026-05-11, Fase 16.2.
//
// Substitui o padrão legacy:
//   <div className='grid grid-batch-form'>
//     <div className='grid-item p-12 t-6 d-4'><field /></div>
//     ...
//     <div className='p-display-flex p-justify-space-between grid-item'>
//       <Button color={COLORS.GREY} startIcon={<DeleteIcon />}>Limpar</Button>
//     </div>
//   </div>
//
// API:
//   open       — se passado, conditional render (mostra se truthy). Default: render incondicional.
//   title      — opcional, Typography overline acima dos fields ('OUTROS FILTROS')
//   onClear    — opcional, renderiza AppButton tertiary 'Limpar filtros' right-aligned no footer
//   clearLabel — opcional, label do botão Limpar. Default 'Limpar filtros'.
//   children   — esperado: <FormGrid> com <FormField span={1|2}> contendo Autocomplete/TextField/DateField
//   sx         — sx overrides do outer Box
//
// Não inclui state de filtros — page controla isso. FilterPanel é só layout.

import React from 'react'
import { Box, Typography } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined'
import AppButton from '../material/AppButton'

export default function FilterPanel({
  open,
  title,
  onClear,
  clearLabel = 'Limpar filtros',
  children,
  sx,
}) {
  // Se prop `open` é passada explicitamente (undefined → render incondicional),
  // respeitar o boolean. Sem prop, sempre renderiza.
  if (open !== undefined && !open) return null

  return (
    <Box
      component="section"
      aria-label={title || 'Filtros'}
      sx={{
        mb: 2,
        pt: 2,
        ...sx,
      }}
    >
      {title && (
        <Typography
          variant="overline"
          sx={{
            display: 'block',
            color: 'text.secondary',
            fontWeight: 600,
            fontSize: '0.6875rem',
            letterSpacing: '0.05em',
            lineHeight: 1,
            mb: 1.5,
          }}
        >
          {title}
        </Typography>
      )}

      {children}

      {onClear && (
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <AppButton
            variant="tertiary"
            startIcon={<DeleteOutlineIcon />}
            onClick={onClear}
          >
            {clearLabel}
          </AppButton>
        </Box>
      )}
    </Box>
  )
}
